export const cardGroupStyle = {
  padding: 30,
}
